export default class FormGroupItem {
    _name;
	_fields;
    _formId;
    _expansible;
    _position;

	constructor({
		name,
		formId,
        fields = [],
        expansible,
        position
	} = {}) {
		this.name = name;
		this.fields = fields;
        this.formId = formId;
        this.expansible = expansible;
		this.position = position;

	}

    get name() {
		return this._name;
	}

	set name(value) {
		this._name = value;
    }

    get fields() {
		return this._fields;
    }

	set fields(value) {
		this._fields = value;
    }

    get formId() {
		return this._formId;
	}

	set formId(value) {
		this._formId = value;
    }

    get expansible() {
		return this._expansible;
	}

	set expansible(value) {
		this._expansible = value;
    }

    get position() {
		return this._position;
	}

	set position(value) {
		this._position = value;
	}
}
